module.exports = __webpack_public_path__ + "img/nutrieon-energy-84x114-2.87af5fb6.png";